import { EStatusType } from 'src/types/enums/EStatusType'

import { ProgressIndicator } from './ProgressIndicator'

export const ExportSuccessful = (
  <ProgressIndicator status={EStatusType.completed}>Export complete</ProgressIndicator>
)
